import { useRef, useCallback, useEffect } from 'react'

interface IPropsUnmountMedia {
  duration: number
  playedSeconds?: number
  playing?: boolean
  onPause?: (playedSeconds: number, duration: number) => void
}

export const useUnmountMedia = ({
  duration,
  playedSeconds,
  playing,
  onPause,
}: IPropsUnmountMedia) => {
  const playedSecondsRef = useRef(playedSeconds)
  const playingRef = useRef(playing)
  const durationRef = useRef(duration)

  const unMountHandler = useCallback(() => {
    if (playingRef.current) {
      onPause?.(playedSecondsRef.current || 0, durationRef.current || 0)
    }
  }, [onPause])

  useEffect(() => {
    playedSecondsRef.current = playedSeconds
    playingRef.current = playing
    durationRef.current = duration
  }, [playedSeconds, playing, duration])

  useEffect(() => {
    return () => {
      unMountHandler()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
